import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";
import { shopApi, formatApiError } from "../../lib/shopApi";
import { PasswordInput } from "../../components/shop/PasswordInput";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_loctician-hub/artifacts/fdlrkebv_WhatsApp%20Image%202025-11-21%20at%2012.44.06_ff66975e.jpg";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await shopApi.post("/auth/login", { email, password });
      localStorage.setItem("cc_admin_token", r.data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Invalid email or password"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1C1C1C] text-[#F5EFE3] flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Loctician Carlocs - Johannesburg loctician logo" className="h-14 w-auto mx-auto mb-4" />
          <p className="text-[#C9A24B] text-xs uppercase tracking-[0.35em] flex items-center justify-center gap-2">
            <Lock className="w-3.5 h-3.5" /> Admin Access
          </p>
        </div>
        <form onSubmit={login} className="bg-[#232323] border border-[#C9A24B]/15 rounded-2xl p-7 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#F5EFE3]/50 mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-[#1C1C1C] border border-[#C9A24B]/20 rounded-xl px-4 py-3.5 focus:outline-none focus:border-[#C9A24B] transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#F5EFE3]/50 mb-2">Password</label>
            <PasswordInput
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              toggleTestId="admin-password-toggle"
              className="w-full bg-[#1C1C1C] border border-[#C9A24B]/20 rounded-xl px-4 py-3.5 pr-12 focus:outline-none focus:border-[#C9A24B] transition-colors"
            />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-btn"
            className="w-full bg-[#C9A24B] text-[#1C1C1C] py-4 rounded-full text-xs font-bold uppercase tracking-widest hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <Crown className="w-4 h-4" /> {busy ? "Signing In…" : "Sign In"}
          </button>
        </form>
        <p className="text-center mt-6">
          <Link to="/" className="text-[#F5EFE3]/40 hover:text-[#C9A24B] text-xs transition-colors">← Back to site</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
